import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import TextareaAutosize from '@material-ui/core/TextareaAutosize';
import MaterialTable from "material-table";
import {
  MuiThemeProvider,
  createMuiTheme,
  makeStyles,
  createStyles,
} from "@material-ui/core/styles";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";

import { KeyboardDatePicker } from "@material-ui/pickers";
import { MuiPickersUtilsProvider } from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import format from "date-fns/format";

import { initializeApp, getApps, getApp } from "firebase/app";
import {
  getFirestore,
  collection,
  doc,
  query,
  where,
  orderBy,
  startAfter,
  limit,
  getDoc,
  getDocs,
  onSnapshot,
  Timestamp
} from "firebase/firestore";

// import {
//   getAllAddressAPICall,
//   getAddress,
//   getZones,
//   getWards,
// } from "../../Address";

import { devicePhaseCode, deviceModeCode, serviceType, ticketStates, ticketDeviceTypes } from "../../constants/constants";

import { checkUserAccess, db, getCheckSession, getUserName, logout } from "../../apis/auth";
import DeviceAddressService from "../../apis/device-address";
import { createTicket, getAllTickets } from "../../query/ticket.query"
import DeviceDataService from "../../apis/device-data"
import "../../styles/active-tickets.scss";
import "../../styles/reports.scss";
import { exportMaterialTableToExcel, exportMaterialTableToPDF, format2Decimals, getDateString, getDateStringHHMMSS } from "../../utilities/utility";
import { ExportCsv, ExportPdf } from "@material-table/exporters";
import AddIcon from '@material-ui/icons/Add';
import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, FormHelperText, TextField } from "@material-ui/core";
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { useTheme } from '@material-ui/core/styles';
import { NotificationManager } from "react-notifications";
import { v4 as uuidv4 } from 'uuid';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import Menu from "@material-ui/core/Menu";
import { et } from "date-fns/locale";
import { getZoneComMob, getZoneContact } from "../../query/config.query";

const useStyles = makeStyles((theme) =>
  createStyles({
    button: {
      margin: theme.spacing(1),
    },
    table: {
      minWidth: 650,
    },
    root: {
      width: "100%",
    },
    instructions: {
      marginTop: theme.spacing(1),
      marginBottom: theme.spacing(1),
    },
    formControl: {
      margin: theme.spacing(1),
      minWidth: 120,
      marginRight: 20,
    },
    selectEmpty: {
      marginTop: theme.spacing(2),
    },
  })
);

const CreateTickets = (props) => {
  const classes = useStyles();
  const history = useHistory();
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));

  const [deviceTypeList, setDeviceTypeList] = useState([]);
  const [ctDeviceType, setCtDeviceType] = useState(-1);
  const [deviceTypeError, setDeviceTypeError] = useState("");
  const [zoneContacts, setZoneContacts] = useState(0);
  const [zoneComList, setZoneComList] = useState([]);
  const [ctZone, setCtZone] = useState(0);
  const [ctZoneError, setCtZoneError] = useState("");
  const [ctWard, setCtWard] = useState(0);
  const [ctWardError, setCtWardError] = useState("");
  const [ctDeviceID, setCtDeviceID] = useState([]);
  const [ctDeviceIDError, setCtDeviceIDError] = useState("");
  const [ctStreetName, setCtStreetName] = useState("");
  const [ctStreetNameError, setCtStreetNameError] = useState("");
  const [ctComplaintBy, setCtComplaintBy] = useState("");
  const [ctComplaintByError, setCtComplaintByError] = useState("");
  const [ctComplaintByMNum, setCtComplaintByMNum] = useState("");
  const [ctComplaintByMNumError, setComplaintByMNumError] = useState("");
  const [ctDescription, setCtDescription] = useState([]);
  const [ctDescriptionError, setCtDescriptionError] = useState("");
  const [ctAssigneeMobile, setCtAssigneeMobile] = useState([]);
  const [ctMobileError, setCtMobileError] = useState("");
  const [ctAssignee, setCtAssignee] = useState([]);
  const [ctAssigneeError, setCtAssigneeError] = useState("");


  // const [filterObj, setFilterObj] = useState({
  //   zone: 0,
  //   ward: 0,
  //   ccms: 0,
  //   startDate: new Date(),
  //   endDate: new Date(),
  // });
  const [zoneFilterList, setZoneFilterList] = useState([]);
  const [wardFilterList, setWardFilterList] = useState([]);

  // const [ticketList, setTicketList] = useState([]);
  // const [historyDialog, setHistoryDialog] = useState(null);

  ///Update ticket
  // const [updateTicketFlag, setUpdateTicketFlag] = React.useState(null);
  // const [updateTicketData, setUpdateTicketData] = React.useState(null);

  // const showUpdateTicketDialog = (state, data) => {
  //   setUtAssignee(data.ass);
  //   setUpdateTicketFlag(state);
  //   setUpdateTicketData(data);
  // }

  // const hideUpdateTicketDialog = () => {
  //   setUpdateTicketFlag(null);
  //   setUpdateTicketData(null);
  //   resetUpdateTicket();
  // }

  /// Create Ticket Dialog
  // const [createTicketFlag, setCreateTicketFlag] = React.useState(false);

  // const showCreateTicketDialog = () => {
  //   setCreateTicketFlag(true);
  // }

  const hideCreateTicketDialog = () => {
    resetCreateTicket();
    // setCreateTicketFlag(false);
  }

  /// Table Filter
  // const [statusTableFilter, setStatusTableFilter] = React.useState(0);
  // const [statusTableFilterList, setStatusTableFilterList] = useState([]);

  // const handleErrorFilterChange = (event) => {
  //   setStatusTableFilter(event.target.value);
  // };

  useEffect(async () => {
    console.log("========== Create Ticket : OnInit() ==========");
    var sessionStatus = await getCheckSession();
    var ticketAccess = checkUserAccess("ticket");
    var createTicketStatus = checkUserAccess("create_ticket");
    if (sessionStatus === false || createTicketStatus === false || ticketAccess === false) {
      history.push("/");
      return;
    }

    // ///Ticket state list
    // let statusList = [{label: "All",value: -1}];
    // for (const statusCode in ticketStates) {
    //   if (![3].includes(statusCode)) {
    //     statusList.push({
    //       label: ticketStates[statusCode],
    //       value: statusCode,
    //     });
    //   }
    // }
    // setStatusTableFilterList(statusList);

    /// Device type list

    let devList = [];
    for (const devTypeCode in ticketDeviceTypes) {
      devList.push({
        label: ticketDeviceTypes[devTypeCode],
        value: devTypeCode,
      });
    }
    setDeviceTypeList(devList);


    /// Get ward zone detail
    await DeviceAddressService.getInstance().getAllAddressAPICall();
    let zoneList = DeviceAddressService.getInstance().getZones();
    let wardList = DeviceAddressService.getInstance().getWards(zoneList[0].value);
    setZoneFilterList(zoneList);
    setWardFilterList(wardList);
    console.log(`==> Zone list ${zoneList}\n\n WardList = ${wardList}`);
    setCtZone(zoneList[0].value);
    setCtWard(wardList[0].value);
    // setFilterObj((prevState) => ({
    //   ...prevState,
    //   zone: zoneList[0].value,
    //   ward: wardList[0].value,
    // }));
    // await fetchTicket(0,0,[0,1,3]);

    /// get zone contacts
    await getZoneContact().then((response) => {
      console.log(`getZoneContact => ${response}`);
      setZoneContacts(response);
    }).catch((error) => {
      console.log(error);
    });

    await getZoneComMob().then((response) => {
      console.log(`getZoneComList => ${response}`);
      setZoneComList(response.com_list);
    }).catch((error) => {
      console.log(error);
    });
  }, []);

  // const fetchTicket = async (zone = 0, ward = 0, states = [0,1,2,3]) => {
  //   var data = await getAllTickets(zone, ward, states).catch((e)=> {
  //     console.log(e);
  //     return;
  //   });
  //   console.log("===> rec : ",JSON.stringify(data));
  //   setTicketList(data);
  // }

  const handleFilterChange = async (e) => {
    const { target: { name = "", value = "" } = {} } = e;
    if (name === "deviceType") {
      setCtDeviceType(parseInt(value));
    } else if (name === "zone") {
      let wardList = DeviceAddressService.getInstance().getWards(value);
      setWardFilterList(wardList);
      setCtZone(value);
      setCtWard(wardList[0].value);

      // if (zoneContacts != null) {
      //   var zoneContact = zoneContacts["zoneList"].find((contact) => contact.zone == value);
      //   if (zoneContact != null) {
      //     setCtAssignee(zoneContact["comNam"]);
      //     setCtAssigneeMobile(zoneContact["comMob"]);
      //   } else {
      //     setCtAssignee('');
      //     setCtAssigneeMobile('');
      //   }
      // }
    } else if (name === "ward") {
      setCtWard(value);
    }
  }

  const onClickCreateTicket = async () => {
    var error = false;
    const user = await getUserName().catch((error) => {
      error = true;
      console.error(`User name not found. error = ${error}`);
    });

    if (ctDeviceType == -1) {
      setDeviceTypeError("Select device Type");
      error = true;
    } else {
      setDeviceTypeError("");
    }

    if (ctZone == 0) {
      setCtZoneError("Select zone");
      error = true;
    } else {
      setCtZoneError("");
    }

    if (ctWard == 0) {
      setCtWardError("Select ward");
      error = true;
    } else {
      setCtWardError("");
    }

    if (ctStreetName == 0) {
      setCtStreetNameError("Enter street name");
      error = true;
    } else {
      setCtStreetNameError("");
    }

    if (ctDeviceID == "" || ctDeviceID.length <= 0) {
      setCtDeviceIDError("Enter device ID");
      error = true;
    } else {
      setCtDeviceIDError("");
    }

    if (ctDescription == "") {
      setCtDescriptionError("Enter complaint");
      error = true;
    } else if (ctDescription.length > 500) {
      setCtDescriptionError("Enter complaint less than 500 charectors");
      error = true;
    } else {
      setCtDescriptionError("");
    }

    if (ctComplaintBy == "" || ctComplaintBy.length <= 0) {
      setCtComplaintByError("Enter complainant name");
      error = true;
    } else {
      setCtComplaintByError("");
    }

    if (ctComplaintByMNum == "" || ctComplaintByMNum.length <= 0) {
      setComplaintByMNumError("Enter complainant phone number");
      error = true;
    } else {
      setComplaintByMNumError("");
    }

    if (ctAssignee == "" || ctAssignee.length <= 0) {
      setCtAssigneeError("No one assigned");
      error = true;
    } else {
      setCtAssigneeError("");
    }

    if (error) {
      return;
    }
    var createdDate = Timestamp.fromDate(new Date());
    var data = {
      id: uuidv4(),
      dt: ctDeviceType,
      zn: ctZone,
      wd: ctWard,
      strt: ctStreetName,
      dev_id: ctDeviceID,
      desc: ctDescription,
      ct: createdDate,
      mt: createdDate,
      ass: ctAssignee,
      assMob: ctAssigneeMobile,
      comNam: ctComplaintBy,
      comMob: ctComplaintByMNum,

      st: ctAssignee.length > 0 ? 1 : 0,
      usr: user,
      history: [
        {
          ct: createdDate,
          st: ctAssignee.length > 0 ? 1 : 0,
          ass: ctAssignee,
          com: "",
          usr: user,
        }
      ]
    }
    await createTicket(data).catch((e) => {
      NotificationManager.error("Failed to create ticket.", "", 3000);
      console.log(e)
      return;
    });
    hideCreateTicketDialog();
    NotificationManager.success("Ticket created successfully", "", 3000);
    resetCreateTicket();
    // await fetchTicket(0,0,[0,1,3]);
  }

  const resetCreateTicket = () => {
    setCtDeviceType(-1);
    setCtZone(zoneFilterList[0].value);
    setCtWard(wardFilterList[0].value);
    setCtDeviceID('');
    setCtDescription('');
    setCtAssigneeMobile('');
    setCtAssignee('');
    setCtComplaintBy('');
    setCtComplaintByMNum('');

    setDeviceTypeError("");
    setCtZoneError("");
    setCtWardError("");
    setCtStreetName("");
    setCtDeviceIDError("");
    setCtDescriptionError("");
    setCtMobileError("");
    setCtAssigneeError("");
    setCtComplaintByError("");
    setComplaintByMNumError("");

  }

  /* Contect Menu */
  const [anchorMore, setAnchorMore] = React.useState(null);
  const [actionMenu, setActionMenu] = React.useState(null);

  const handleContextMenuAction = async (event, data) => {
    console.log("row click", data);
    setAnchorMore(event.currentTarget);
    setActionMenu(data ?? null);
  }

  return (
    <div className="root-container reports">
      <h2 className="reports-header">Create Tickets</h2>
      <div className="reports-filter-wrapper">
        <div className="reports">
          <FormControl className="dialog-form" style={{ width: '100%', margin: '10px 0' }} error={deviceTypeError.length > 0 ? true : false}>
            {/* Device Type */}
            <InputLabel id="device-type-label">Device Type</InputLabel>
            <Select
              autoFocus
              required
              labelId="device-type-label"
              id="device-type-label"
              name="deviceType"
              value={ctDeviceType}
              onChange={handleFilterChange}
              label="Device Type"
            >
              {/* <MenuItem value={"all"}>All</MenuItem> */}
              {deviceTypeList.map((item) => (
                <MenuItem key={item.value} value={item.value}>
                  {item.label}
                </MenuItem>
              ))}
            </Select>
            <FormHelperText>{deviceTypeError}</FormHelperText>
          </FormControl>
          <FormControl className="dialog-form" style={{ width: '100%', margin: '10px 0' }} error={ctZoneError.length > 0 ? true : false}>
            {/* Zone */}
            <InputLabel id="zone-label">Zone</InputLabel>
            <Select
              required
              labelId="zone-label"
              id="zone"
              name="zone"
              value={ctZone}
              onChange={handleFilterChange}
              label="Zone"
            >
              {zoneFilterList.map((item) => (
                <MenuItem key={item.value} value={item.value}>
                  {item.label}
                </MenuItem>
              ))}
            </Select>
            <FormHelperText>{ctZoneError}</FormHelperText>
          </FormControl>
          {/* Ward */}
          <FormControl className="dialog-form" style={{ width: '100%', margin: '10px 0' }} error={ctWardError.length > 0 ? true : false}>
            <InputLabel id="ward-label">Ward</InputLabel>
            <Select
              required
              labelId="ward-label"
              id="ward"
              name="ward"
              value={ctWard}
              onChange={handleFilterChange}
              label="Ward"
            >
              {wardFilterList.map((item) => (
                <MenuItem value={item.value}>{item.label}</MenuItem>
              ))}
            </Select>
            <FormHelperText>{ctZoneError}</FormHelperText>
          </FormControl>
          {/* Street name */}
          <FormControl className="dialog-form" style={{ width: '100%', margin: '0px 0' }} >
            <TextField
              error={ctStreetNameError.length > 0 ? true : false}
              autoFocus
              margin="dense"
              id="street"
              label="Street"
              type="text"
              value={ctStreetName}
              onChange={(e) => {
                setCtStreetName(e.target.value);
              }}
              helperText={ctStreetNameError}
            />
          </FormControl>
          {/* Device ID */}
          <FormControl className="dialog-form" style={{ width: '100%', margin: '0px 0' }} >
            <TextField
              error={ctDeviceIDError.length > 0 ? true : false}
              autoFocus
              margin="dense"
              id="deviceId"
              label="Device ID"
              type="text"
              value={ctDeviceID}
              onChange={(e) => {
                setCtDeviceID(e.target.value);
              }}
              helperText={ctDeviceIDError}
            />
          </FormControl>
          {/* Complaint detail */}
          <FormControl className="dialog-form" style={{ width: '100%', margin: '10px 0' }}>
            <label className="MuiFormLabel-root MuiInputLabel-root MuiInputLabel-formControl MuiInputLabel-animated MuiInputLabel-shrink MuiFormLabel-filled">Complaint</label>
          </FormControl>
          <FormControl className="dialog-form" style={{ width: '100%', margin: '10px 0px 0px 0px' }} >
            <TextareaAutosize
              error={ctDescriptionError.length > 0 ? true : false}
              labelId="complaint-label"
              label="Complaint"
              minRows={5}
              maxRows={5}
              aria-label="Complaint"
              placeholder="Maximum 500 charectors"
              value={ctDescription}
              onChange={(e) => {
                setCtDescription(e.target.value);
              }}
              helperText={ctDescriptionError}
            />
            <FormHelperText className="Mui-error">{ctDescriptionError}</FormHelperText>
          </FormControl>
          {/* Complainant Name */}
          <FormControl className="dialog-form" style={{ width: '100%', margin: '0px 0' }}>
            <TextField
              error={ctComplaintByError.length > 0 ? true : false}
              margin="dense"
              id="complaint_by"
              label="Complainant Name"
              type="text"
              value={ctComplaintBy}
              onChange={(e) => {
                setCtComplaintBy(e.target.value);
              }}
              helperText={ctComplaintByError}
            />
          </FormControl>
          {/* Complainant Phone Number */}
          <FormControl className="dialog-form" style={{ width: '100%', margin: '0px 0' }}>
            <TextField
              error={ctComplaintByMNumError.length > 0 ? true : false}
              autoFocus
              margin="dense"
              id="complainant_phone_number"
              label="Complainant Phone Number"
              type="text"
              value={ctComplaintByMNum}
              onChange={(e) => {
                setCtComplaintByMNum(e.target.value);
              }}
              helperText={ctComplaintByMNumError}
            />
          </FormControl>
          <FormControl className="dialog-form" style={{ width: '100%', margin: '10px 0' }} error={ctAssigneeError.length > 0}>
            <InputLabel id="assignee-label">Assigned to</InputLabel>
            <Select
              labelId="assignee-label"
              id="assignee"
              value={ctAssignee ? `${ctAssignee} - ${ctAssigneeMobile}` : ''}
              onChange={(e) => {
                const [name, mobile] = e.target.value.split(' - ');
                setCtAssignee(name);
                setCtAssigneeMobile(mobile);
              }}
            >
              {zoneComList.map((item, index) => (
                <MenuItem key={index} value={`${item.name} - ${item.mobile}`}>
                  {item.name} - {item.mobile}
                </MenuItem>
              ))}
            </Select>
            {ctAssigneeError && <FormHelperText>{ctAssigneeError}</FormHelperText>}
          </FormControl>

          <div className="edit-btn-wrapper" style={{ display: "flex", marginTop: "20px" }}>
            <Button onClick={hideCreateTicketDialog} color="primary" variant="contained"
              className="edit-btn" style={{ marginLeft: "auto" }}>
              Cancel
            </Button>
            <Button onClick={onClickCreateTicket} color="primary" variant="contained"
              className="edit-btn" style={{ marginLeft: "40px" }}>
              Create
            </Button>
            {/*     <Button
                variant="contained"
                className="edit-btn"
                onClick={handleEdit}
              >
                Edit
              </Button> */}
          </div>
          {/* <div style={{ display: "flex" }}>
          
          
          </div> */}
        </div>
      </div>
    </div>
  );
};
export default CreateTickets;
